import axios from "axios";
import {
	LOGIN_SUCCESS,
	LOGIN_FAIL,
	LOGOUT,
	USER_LOADED,
	CLEAR_PRINTER,
	CLEAR_PRODUCT,
} from "./types";
import setAuthToken from "../utils/setAuthToken";
import { toastr } from "react-redux-toastr";

//  Load User
export const loadUser = () => async (dispatch) => {
	if (localStorage.token) {
		setAuthToken(localStorage.token);
	}
	try {
		const res = await axios.get("/api/auth/admin");
		dispatch({
			type: USER_LOADED,
			payload: res.data,
		});
	} catch (err) {
		dispatch({
			type: LOGIN_FAIL,
		});
	}
};

// Login USER
export const login = (email, password) => async (dispatch) => {
	const config = {
		headers: {
			"Content-Type": "application/json",
		},
	};
	const body = JSON.stringify({ email, password });
	try {
		const res = await axios.post("/api/auth/admin", body, config);
		dispatch({
			type: LOGIN_SUCCESS,
			payload: res.data,
		});
		dispatch(loadUser());
	} catch (err) {
		const errors = err.response.data.errors;
		if (errors) {
			errors.forEach((error) => toastr.error(error.msg));
		}
		dispatch({
			type: LOGIN_FAIL,
		});
	}
};

// The backend's { errors: [{ msg }] }, or one for a server that did not answer
const errorsOf = (err) =>
	(err.response && err.response.data && err.response.data.errors) || [
		{ msg: "Сервертэй холбогдож чадсангүй" },
	];

// The link mailed to a new admin, or to one whose password was reset: whose it
// is, while it works. Returns { link: { name, email, pending } } or { errors }.
export const checkPasswordLink = (token) => async () => {
	try {
		const res = await axios.post("/api/auth/password-link", { token });
		return { link: res.data };
	} catch (err) {
		return { errors: errorsOf(err) };
	}
};

// Sets the password of the admin whose link it is; the link then stops working.
// Returns { email } or { errors }.
export const setPassword = (token, password) => async () => {
	try {
		const res = await axios.post("/api/auth/set-password", { token, password });
		return { email: res.data.email };
	} catch (err) {
		return { errors: errorsOf(err) };
	}
};

// Logout / Clear Profile
export const logout = () => (dispatch) => {
	dispatch({
		type: LOGOUT,
	});
	dispatch({
		type: CLEAR_PRODUCT,
	});
	dispatch({
		type: CLEAR_PRINTER,
	});
};
